import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class FirestoreService {
  constructor(private firestore: AngularFirestore) { }

  // Create Consultation
  public createConsultation(data: any) {
    return this.firestore.collection('consultations').add(data);
  }

  // Get Consultation
  public getConsultation(documentId: string) {
    return this.firestore.collection('consultations').doc(documentId).snapshotChanges();
  }

   // db.collection('consultations').where('lendingName', '==', prestacion).orderBy('creationDate','asc').get();
  // Get Consultations
  public getConsultations() {
    return this.firestore.collection('consultations').snapshotChanges();
  }

  // Update Consultation
  public updateConsultation(documentId: string, data: any) {
    return this.firestore.collection('consultations').doc(documentId).set(data);
  }

  // Create Professional
  public createProfessional(data: any) {
    return this.firestore.collection('professionals').add(data);
  }

  // Get Professional
  public getProfessional(documentId: string) {
    return this.firestore.collection('professionals').doc(documentId).snapshotChanges();
  }

  // Get Professionals
  public getProfessionals() {
    return this.firestore.collection('professionals').snapshotChanges();
  }

  // Update Professional
  public updateProfessional(documentId: string, data: any) {
    return this.firestore.collection('professionals').doc(documentId).set(data);
  }

  // Delete Professional
  public deleteProfessional(documentId: string) {
    return this.firestore.collection('professionals').doc(documentId).delete();
  }


  // Create Lending
  public createLending(data: any) {
    return this.firestore.collection('lendings').add(data);
  }

  // Get Lending
  public getLending(documentId: string) {
    return this.firestore.collection('lendings').doc(documentId).snapshotChanges();
  }

  // Get Lendings
  public getLendings() {
    return this.firestore.collection('lendings').snapshotChanges();
  }

  // Update Lending
  public updateLending(documentId: string, data: any) {
    return this.firestore.collection('lendings').doc(documentId).set(data);
  }

  // Delete Lending
  public deleteLending(documentId: string) {
    return this.firestore.collection('lendings').doc(documentId).delete();
  }
}